<div class="slider-back" [hidden]="!showShadow">

</div>

<div [hidden]="!showShadow">
    <div class="slider" [ngClass]="{'shadow' : showShadow === true}" [@slideInOut]="animationState">
        <div class="tab-header">Create/Edit Application
            <div class="btn-close-position" (click)="changeState(2)">
                <div class="btn-close">
                    <img src="assets/images/icons/Close.png">
                </div>
            </div>

        </div>
        <div class="conent">
            <form (submit)="f.valid" class="form col-sm-12" #f="ngForm">
                <label class="labelPopup">Configuration name</label>
                <input class="form-control" name="name" [(ngModel)]="selectedApp.displayName" #name="ngModel" required
                    autocomplete="off" placeholder="Configuration name"/>
                <div *ngIf="f.submitted && name.invalid" class="form-control-error">Configuration name is required</div>
                <br>
                <label class="labelPopup">Application name</label>
                <input class="form-control" name="appName" [(ngModel)]="selectedApp.applicationName" #appName="ngModel" required
                    autocomplete="off" placeholder="Application name"/>
                <div *ngIf="f.submitted && appName.invalid" class="form-control-error">Application name is required</div>
                <br>
                <div class="urlDiv">
                    <label class="labelPopup">RedirectUrl (Login)</label>
                    <div *ngFor="let item of selectedApp.loginUrls;  let i=index; trackBy: trackByFn" class="urlDivIn">
                            <div class="inputUrl">
                                <input type="text" class="form-control" name="loginUrls{{i}}" [(ngModel)]="selectedApp.loginUrls[i]"
                                    #loginUrls="ngModel" required pattern="(?:https?://.+|my\.app:/oauth2redirect)" id="loginUrls{{i}}"
                                    placeholder="RedirectUrl for Login {{i+1}}" autocomplete="off"/>
                            <!-- <div *ngIf="f.submitted && loginUrls.invalid" class="form-control-error">Login URL is required</div> -->
                            </div>
                            <div class="button-url">
                                <button class="btn" (click)="$event.stopPropagation(); deleteUrl(i)">
                                    <img src="assets/images/icons/CloseWhite.png" alt="Remove icon">
                                </button>
                            </div>
                    </div>
                    <div class="button-remove">
                        <button class="btn" (click)="$event.stopPropagation(); incRedUrls()">
                            <img src="assets/images/icons/add-w.svg" alt="Add icon"> Add URL
                        </button>
                    </div>
                </div>
                <br>
                <input class="form-control" name="url" [(ngModel)]="selectedApp.url" #url="ngModel" required
                    pattern="https?://.+" autocomplete="off" placeholder="Url application" />
                <div *ngIf="f.submitted && url.invalid" class="form-control-error">Application URL is required</div>
                <label class="labelPopup">Use 2FA</label>
                <div class="utility-item-area">
                    <div (click)="use2FAClick()">
                        <div class="switch-wrapper" [ngClass]="{'selected' : selectedApp.use2FA}">
                            <div class="switch"></div>
                        </div>
                    </div>
                </div>
                <br>
                <label class="labelPopup">Use Microsoft Login</label>
                <div class="utility-item-area">
                    <div (click)="useMicrosoftLogin()">
                        <div class="switch-wrapper" [ngClass]="{'selected' : selectedApp.microsoftLoginEnabled}">
                            <div class="switch"></div>
                        </div>
                    </div>
                </div>
                <br>
            </form>
        </div>
        <div class="sticky user-btn">
            <button class="submit col-xs-6" [disabled]="!f.valid" (click)="save()">Save</button>
            <button class="cancel-btn col-xs-6" (click)="changeState(2)">Cancel</button>
        </div>
    </div>
</div>